import { DefaultIframeDimensions, embedServiceTypes, genericEmbedDomainPattern, oEmbedProviders, PixelRegex } from 'ContentData/constants/embed';
import MediaSizeTypes from 'ContentUtils/constants/MediaSizeTypes';
const truncate = n => n - n % 1;
export const calcDimensionsWidth = (widthValue, aspectRatio, isMax) => {
  if (isNaN(widthValue) || !widthValue) return null;
  let widthKey = 'width';
  let heightKey = 'height';
  if (isMax) {
    widthKey = 'max_width';
    heightKey = 'max_height';
  }
  const dimensions = {
    [widthKey]: truncate(widthValue || 0)
  };
  if (aspectRatio) {
    dimensions[heightKey] = Math.round(dimensions[widthKey] * (1 / aspectRatio));
  }
  return dimensions;
};
export const calcDimensionsHeight = (heightValue, aspectRatio, isMax) => {
  if (isNaN(heightValue) || !heightValue) return null;
  let heightKey = 'height';
  let widthKey = 'width';
  if (isMax) {
    heightKey = 'max_height';
    widthKey = 'max_width';
  }
  const dimensions = {
    [heightKey]: truncate(heightValue || 0)
  };
  if (aspectRatio) {
    dimensions[widthKey] = Math.round(dimensions[heightKey] * aspectRatio);
  }
  return dimensions;
};
export const EMPTY_EMBED_VALUE = {
  height: undefined,
  max_height: undefined,
  max_width: undefined,
  oembed_response: undefined,
  size_type: MediaSizeTypes.AUTO,
  width: undefined
};

/*
When oEmbed data becomes stale we want to clear it out from the field value, but
because of deep merging occurring in the editors we have to set all properties to
undefined rather than being able to directly delete these properties from the value.
(particularly the more deeply nested values i.e. value.media_bridge_object.oembed_response...)
*/
export const getEmptyOEmbedValue = value => {
  const emptyValue = EMPTY_EMBED_VALUE;
  const {
    oembed_response
  } = value || {};
  const emptyOEmbedResponse = Object.keys(oembed_response || {}).reduce((obj, key) => {
    obj[key] = undefined;
    return obj;
  }, {});
  emptyValue.oembed_response = emptyOEmbedResponse;
  return emptyValue;
};

// code below copied from https://git.hubteam.com/HubSpot/hubspot-tinymce/blob/master/tinymce-plugins/static-1.49366/js/hsmedia/util.js

const scriptRegex = /<script[\s\S]*?>[\s\S]*?<\/script>/;

// Checks for the presence of a script tag in the html
export const checkForEmbedScripts = (html = '') => scriptRegex.test(html);
const parser = new DOMParser();
export const calcInverseAspectRatio = ({
  width,
  height
} = {}) => {
  if (!PixelRegex.test(`${width}`) || !PixelRegex.test(`${height}`)) {
    width = DefaultIframeDimensions.WIDTH;
    height = DefaultIframeDimensions.HEIGHT;
  }
  const ratio = Number(height) / Number(width);
  return Number((ratio * 100).toFixed(2));
};

// Wrap the iframe or video node in a responsive <div>
export const generateResponsiveEmbed = (html = '', {
  width,
  height
} = {}) => {
  const {
    body
  } = parser.parseFromString(html, 'text/html');
  const targetEls = body.querySelectorAll('iframe,video');
  let dimensions = {
    width,
    height
  };
  if (targetEls.length === 1) {
    const embedContent = targetEls[0];
    if (embedContent.parentElement === body) {
      if (!width || !height) {
        dimensions = {
          width: embedContent.getAttribute('width'),
          height: embedContent.getAttribute('height')
        };
      }
      const responsiveEmbedInnerWrapperStyles = `
        position: relative;
        overflow: hidden;
        max-width: 100%;
        margin: 0;
        padding-bottom: ${calcInverseAspectRatio(dimensions)}%;
      `;
      const responsiveEmbedIframeStyles = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
      `;
      const responsiveWrapper = document.createElement('div');
      responsiveWrapper.style.cssText = responsiveEmbedInnerWrapperStyles;
      embedContent.style.cssText = `${embedContent.style.cssText} ${responsiveEmbedIframeStyles}`;
      responsiveWrapper.appendChild(embedContent.cloneNode(true));
      body.replaceChild(responsiveWrapper, embedContent);
      html = body.innerHTML;
    }
  }
  return {
    dimensions,
    html
  };
};
export const identifyEmbedService = html => {
  const embedService = embedServiceTypes.find(type => type.pattern.test(html));
  if (embedService && embedService.type) return embedService.type;
  const domain = genericEmbedDomainPattern.find(pattern => pattern.test(html));
  if (domain) return domain.exec(html)[1];
  return '';
};
export const updateRichEmbed = (htmlString, provider = '') => {
  if (!provider) provider = identifyEmbedService(htmlString);
  const tempDoc = parser.parseFromString(htmlString, 'text/html');
  let updated = false;

  /**
   * TODO: We should be able to use oembed params for these in the insert modal
   */
  if (provider.toLowerCase() === oEmbedProviders.TWITTER) {
    // Automatically center all twitter embeds
    const blockquote = tempDoc.querySelector('blockquote');
    if (blockquote) blockquote.setAttribute('align', 'center');
    updated = true;
  } else if (provider.toLowerCase() === oEmbedProviders.INSTAGRAM) {
    // We can hide caption if we want to
    // const blockquote = tempDoc.querySelector('blockquote');
    // blockquote.removeAttribute('data-instgrm-captioned');
    // updated = true;
  }
  return updated ? tempDoc.body.innerHTML : htmlString;
};

// Creates an image tag of 100% width
export const generateResponsiveEmbedImage = url => {
  return `<img src="${url}" style="width: 100%;" />`;
};